import { render, staticRenderFns } from "./OrderCancellationModal.vue?vue&type=template&id=1973c372&scoped=true&"
import script from "./OrderCancellationModal.vue?vue&type=script&lang=ts&"
export * from "./OrderCancellationModal.vue?vue&type=script&lang=ts&"
import style0 from "./OrderCancellationModal.vue?vue&type=style&index=0&id=1973c372&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1973c372",
  null
  
)

export default component.exports